module.exports = __webpack_public_path__ + "static/freight-liability-insurance-35eff55aef6ee0f3fe601b6713931bc6.svg";